export default __webpack_public_path__ + "static/media/logoLoginDentalNew.588474c8.jpeg";